import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import axios from 'axios'
import { leaveAxiosNetworkErrorBreadcrumb, leaveHttpErrorBreadcrumb } from './support/bugsnagBreadcrumbs'
import './_alpine'

/**
 * Google Maps Service Loader
 */
import { Loader } from '@googlemaps/js-api-loader'
window.Loader = Loader;


/**
 * BUGSNAG
 * Vue is registered later in _vue.js via installVueErrorHandler (plugin is lazy-loaded without Vue in constructor).
 */
const bugsnagVuePlugin = new BugsnagPluginVue()

const bugsnagMeta = document.head.querySelector('meta[name="bugsnag-config"]');

if (bugsnagMeta) {
    let parsed = null;
    try {
        parsed = JSON.parse(bugsnagMeta.getAttribute('content') || '{}');
    } catch (e) {
        console.warn('[Bugsnag] Invalid bugsnag-config JSON', e);
    }

    if (parsed && parsed.apiKey && typeof parsed.apiKey === 'string') {
        try {
            Bugsnag.start({
                apiKey: parsed.apiKey,
                releaseStage: parsed.releaseStage,
                autoTrackSessions: parsed.autoTrackSessions !== false,
                collectUserIp: false,
                plugins: [bugsnagVuePlugin],
                redactedKeys: [
                    /email/i,
                    /password/i,
                    /token/i,
                    /phone/i,
                    /address/i,
                    'password',
                    'password_confirmation',
                ],
                onError: (event) => {
                    event.clearMetadata('vue', 'props');
                },
            });

            if (parsed.userId != null && parsed.userId !== '') {
                Bugsnag.getClient().setUser(String(parsed.userId));
            }

            window.Bugsnag = Bugsnag;
        } catch (e) {
            console.warn('[Bugsnag] Failed to start notifier', e);
        }
    }
}

/**
 * AXIOS
 */
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * CSRF TOKEN
 */
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * API TOKEN
 */
let apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
    window.axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken.content}`;
}

axios.interceptors.response.use(
    (response) => response,
    (err) => {
        if (err.response && err.response.status >= 400) {
            leaveHttpErrorBreadcrumb(err.config, err.response.status);
        } else if (err.request && !err.response) {
            leaveAxiosNetworkErrorBreadcrumb(err);
        }
        return Promise.reject(err);
    },
);

/**
 * Swiper.js
 */
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

/**
 * Embla Carousel
 */
import EmblaCarousel from 'embla-carousel';
window.EmblaCarousel = EmblaCarousel;

/**
 * STRIPE
 */
function configureStripe() {
    const stripeKey = document.head.querySelector('meta[name="stripe-key"]');

    if (typeof window.Stripe === 'function' && stripeKey) {
        // Boot the stripe js library to enable its fraud detection on all pages
        try {
            window.stripe = Stripe(stripeKey.content);
        } catch (e) {
        }
    }
}
window.configureStripe = configureStripe;

/**
 * YOUTUBE
 */
// Load the YouTube iframe js library
try {
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
} catch (e) {}

